<template>
  <div @click.stop="stop" :style="{visibility: (visible ? 'inherit' : 'hidden')}">
    <slot></slot>
  </div>
</template>

<script>
import Vue from 'vue'
import datelib from '@/lib/date.js';
import EventModel from '@/models/event.js'

export default {
  props: ['uuid'],
  data() {
    var ch = this.$cloudserver.channel("events:"+this.uuid);
    return {
      ws_channel: ch,
      event: _.cloneDeep(ch.data)
    };
  },
  watch: {
    "ws_channel.data": {
      handler(val) {
        this.event = _.cloneDeep(val);
      },
      deep: true
    }
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    visible () {
      if(!this.event) return false;
      var ts = this.$store.state.timestamp;
      return ts >= this.event.cached_start_time && ts <= this.event.cached_end_time;
    },
    title() {
      return EventModel.title(this.event);
    },
    start_time() {
      return this.format_date(this.event.cached_start_time)
    },
    end_time() {
      return this.format_date(this.event.cached_end_time)
    }
  },
  methods: {
    format_date (v) {
      return datelib.format_date(v) + " - " + datelib.format_time(v);
    },
    stop() {
      var self = this;
      if(!this.visible) return;
      if(!confirm("Do you really want end this event?\nEvent: "+this.title+"\nStart time: "+this.start_time+"\nEnd time: "+this.end_time)) return;
      this.ws_channel.push("stop", {})
        .receive("ok", (msg) => {
          self.ws_channel.setData(msg);
          self.$message.success("Event was stopped!");
        })
        .receive("error", (msg) => {
          self.$message.success("Unable to stop event!");
        });
    }
  }
}
</script>
